import { useLang } from "@/lib/siteI18n";
import { useState } from "react";
import { Linkedin, MessageCircle, Link2, Check } from "lucide-react";
import { log } from "@/lib/log";

const GOLD = "#C9A96E";

export const ShareButtons = ({ url, title }) => {
  const { t } = useLang();
  const [copied, setCopied] = useState(false);
  const encodedUrl = encodeURIComponent(url);
  const text = encodeURIComponent(`${title}, ${t.article.shareText} : ${url}`);
  const btn = "inline-flex items-center gap-2 px-4 py-2.5 text-xs uppercase tracking-[0.15em] border border-white/15 text-white/70 hover:text-white hover:border-[#C9A96E] transition-colors";

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      log.warn("[share] presse-papiers indisponible :", e);
    }
  };

  return (
    <div className="mt-12 pt-8 border-t border-white/10" data-testid="article-share">
      <p className="text-xs uppercase tracking-luxe mb-4" style={{ color: GOLD }}>{t.article.share}</p>
      <div className="flex flex-wrap gap-3">
        <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`} target="_blank" rel="noopener noreferrer" className={btn} data-testid="share-linkedin">
          <Linkedin size={14} /> LinkedIn
        </a>
        <a href={`https://wa.me/?text=${text}`} target="_blank" rel="noopener noreferrer" className={btn} data-testid="share-whatsapp">
          <MessageCircle size={14} /> WhatsApp
        </a>
        <button type="button" onClick={copy} className={btn} data-testid="share-copy">
          {copied ? <Check size={14} style={{ color: GOLD }} /> : <Link2 size={14} />} {copied ? t.article.copied : t.article.copy}
        </button>
      </div>
    </div>
  );
};
